/**
 * @file 公共actions，用于更改全局配置项
 * @author jiangjun (jiangjun@huatu.com)
 */

// import {
//     userInfo,
//     enumList
// } from '@/common/request'

export default {

    /**
     * 更新全局配置
     */
    updateGlobalConfig({ commit, state }) {
    /**
         * 获取用户的基本信息
         */
    // userInfo()
    //     .then((res) => {
    //         commit('SET_USER_INFO', res.data)
    //         // let permissions = res.data.permissions
    //         // if (!(permissions && Object.keys(permissions).length)) {
    //         //     toast('抱歉！您暂无系统权限，请联系营销业务组相关负责人!', 'error')
    //         // }
    //         /**
    //          * 获取枚举
    //          */
    //         enumList().then((res) => {
    //             commit('SET_ENUM_LIST', res.data)
    //         })
    //     })
    },
}
